import moment from 'moment'
import DATETIME_CONSTANT from '@src/constants/date-time-constants.js'
import { weekDays } from '@src/constants/general-constants.js'
import countriesList from '@src/constants/countriesArray.js'
import 'moment-timezone'
/**
 * Check time comes before or after
 * @param {String} timeOne - Time
 * @param {String} timeTwo - Time
 * @return {Boolean}
 */

export function timeIsbefore(timeOne, timeTwo) {
  return moment(timeOne, DATETIME_CONSTANT.time12H).isBefore(
    moment(timeTwo, DATETIME_CONSTANT.time12H),
  )
}

/**
 * Check time comes before or after
 * @param {String} timeOne - Time
 * @param {String} timeTwo - Time
 * @return {Boolean}
 */

export function timeIsAfter(timeOne, timeTwo) {
  return moment(timeOne, DATETIME_CONSTANT.time12H).isAfter(
    moment(timeTwo, DATETIME_CONSTANT.time12H),
  )
}

/**
 * Format time from one format to other
 * @param {String} time - Time
 * @param {String} currentFormat - Time Format
 * @param {String} convertingFormat - Time Format
 * @return {String} -Converted Time
 */

export function formatTimeOnly(time, currentFormat, convertingFormat) {
  return moment(time, currentFormat).format(convertingFormat)
}
/**
 * Gives timezone in specific format
 * @param {String} date - Date
 * @param {String} date - In specific format

 */
export function formatTimeZone(date) {
  return moment(date).format('Z').split(':').join('')
}
/**
 * Add specific time in current time
 * @param {String} time - Time
 * @param {String} type - Time of type e.g. hours
 * @param {String} addedTime - time want to add
 * @param {String} format - After adding time in which format you want to convert
 * @return {String} -Added time
 */

export function addTimeInCurrentTime(time, type, addedTime, format) {
  return moment(time, DATETIME_CONSTANT.time12H).add(addedTime, type).format(format)
}

/**
 * Get date from DATETIME_CONSTANT with adding UTC time
 * @param {String} dateTime
 * @return {String} date
 */

export function getTimeFromDateWithUTC(dateTime, format = DATETIME_CONSTANT.time12H) {
  return moment(dateTime).format(format)
}

export function getTimeOnly(dateTime, format = DATETIME_CONSTANT.time12H, extention = 'HH:mm') {
  return moment(dateTime, extention).format(format)
}

export function currentUTCDateTimeWithZone() {
  let date = moment(new Date()).format(DATETIME_CONSTANT.DATE_TIME_24)
  return date
}

export function formatDateString(date, dateStringFormat = DATETIME_CONSTANT.DATE) {
  return moment(date).format(dateStringFormat)
}

export function getWeekDayFromDate(date) {
  return weekdays(moment(date).day())
}

function weekdays(day) {
  return weekDays[day - 1]
}

export function formatDate(date = new Date(), format = DATETIME_CONSTANT.DATE) {
  const formatedDate = moment(date).utcOffset(date).format(format)
  return formatedDate
}

export function formatDateFromLocalToUTC(date = new Date(), format = DATETIME_CONSTANT.DATE) {
  const formatedDate = moment(date).format(format)
  return formatedDate
}

export function fromNowMoment(date) {
  const formatedDate = moment(date).fromNow()
  return formatedDate
}

export function getDay(date, format = DATETIME_CONSTANT.DAY_FIRST_LETTER) {
  return moment(date).format(format)
}

/**
 * Get Date from DATETIME_CONSTANT
 * @param {DateTime} dateTime any DATETIME_CONSTANT
 * @return {date} date
 */

export function getDate(dateTime) {
  return dateTime.split('T')[0]
}

/**
 * Get Time from DATETIME_CONSTANT
 * @param {DateTime} dateTime any DATETIME_CONSTANT
 * @return {time} date
 */
export function getTime(dateTime) {
  return dateTime.split('T')[1]
}

export function getMonthStartAndEndDate(date = new Date()) {
  return {
    startOfMonth: moment(date).startOf('month').format(DATETIME_CONSTANT.DATE_TIME_24),
    endOfMonth: moment(date).endOf('month').format(DATETIME_CONSTANT.DATE_TIME_24),
  }
}

export function getTimeZoneList() {
  let timeZone = moment.tz.names()
  let date = formatDateFromLocalToUTC()
  let list = timeZone.map((country, index) => {
    let timeDifference = moment(date).tz(country).format('Z')
    return {
      id: index,
      timeDifference: timeDifference.split(':').join(''),
      title: `(UTC${timeDifference}) ${country.split('/').join(', ')}`,
      zone: country,
      timeDifferenceTitle: timeDifference,
    }
  })
  return list
}
export function getCurrentDate() {
  return moment().toDate()
}
export function getStartTimeOfTheDay(date = new Date(), format = DATETIME_CONSTANT.DATE_TIME_24) {
  return moment(date).startOf('day').format(format)
}

export function getEndTimeOfTheDay(date = new Date(), format = DATETIME_CONSTANT.DATE_TIME_24) {
  return moment(date).endOf('day').format(format)
}

export function currentTimeWithZone(zone = 'Asia/Karachi') {
  let date = moment().tz(zone).format(DATETIME_CONSTANT.DATE_TIME_24)
  return date
}
export function getDaysInMonth(date) {
  if (!date) {
    return 30
  }
  const momentDate = moment(date)
  return momentDate.daysInMonth()
}
export function formatDateRange(startDate, endDate) {
  const start = moment(startDate)
  const end = moment(endDate)

  if (start.isSame(end, 'month') && start.isSame(end, 'year')) {
    return `${start.date()} - ${end.date()} ${start.format('MMM')}, ${start.year()}`
  }

  if (start.isSame(end, 'year')) {
    return `${start.date()} ${start.format('MMM')} - ${end.date()} ${end.format(
      'MMM',
    )}, ${start.year()}`
  }
  return `${start.format('DD MMM YYYY')} - ${end.format('DD MMM YYYY')}`
}
export function isDateInFuture(date) {
  const givenDate = moment(date)

  const currentDate = moment()

  if (givenDate.isSameOrAfter(currentDate, 'day')) {
    return true
  } else {
    return false
  }
}
export function isFutureYear(date) {
  // Create a moment object for the given date
  const givenDate = moment(date)

  // Get the current year
  const currentYear = moment().year()

  // Get the year of the given date
  const givenYear = givenDate.year()

  // Compare the years
  if (givenYear >= currentYear) {
    return true
  } else {
    return false
  }
}
export const formatTime = (value) => {
  // Create a moment object with the given value in minutes
  const time = moment().startOf('day').add(value, 'minutes')

  // Format the time as desired
  return time.format('h:mm a')
}
export function getFormattedTitle(date) {
  // Create a moment object from the given date
  const selectDate = moment(`${date.year}-${date.month + 1}-${date.day}`, 'YYYY-MM-DD')

  // Format the title with day, date, month, and year
  const dateWithDayName = selectDate.format('ddd D MMM YYYY')

  return dateWithDayName
}
export function generateDayNames(dateRange) {
  const startDate = moment(dateRange.startDate)
  const endDate = moment(dateRange.endDate)
  const dayNamesArray = []

  let currentDate = startDate.clone()

  while (currentDate <= endDate) {
    dayNamesArray.push(currentDate.format('ddd'))
    currentDate.add(1, 'days')
  }

  return dayNamesArray
}
export function generateFormattedDatesArray(dateRange) {
  const startDate = moment(dateRange.startDate)
  const endDate = moment(dateRange.endDate)
  const formattedDatesArray = []

  let currentDate = startDate.clone()

  while (currentDate <= endDate) {
    formattedDatesArray.push(currentDate.format('ddd DD MMM YYYY'))
    currentDate.add(1, 'days')
  }

  return formattedDatesArray
}
export function getDatesForMonth(dateMonth) {
  const startOfMonth = moment(dateMonth).startOf('month')
  const endOfMonth = moment(dateMonth).endOf('month')

  // Create an array to hold the dates
  const datesArray = []

  // Loop through each day of the month
  let monthDate = startOfMonth
  while (monthDate <= endOfMonth) {
    datesArray.push(monthDate.format('ddd DD MMM YYYY'))
    monthDate = monthDate.add(1, 'day')
  }
  return datesArray
}
export function isCurrentOrFutureMonth(date) {
  const inputDate = moment(date)
  const currentDate = moment()

  if (inputDate.isSameOrAfter(currentDate, 'month')) {
    return true
  } else {
    return false
  }
}
export function getFormattedMonthRange(inputDate) {
  // Parse start and end dates
  const startDate = moment(inputDate.start) // Ensure this is a valid date
  const endDate = moment(inputDate.end) // Ensure this is a valid date

  // Check if startMonth is greater than endMonth
  if (startDate.isAfter(endDate)) {
    return 'Start month is greater than end month.'
  }

  // Check if startMonth and endMonth are not consecutive
  const monthsDifference = endDate.diff(startDate, 'months')
  if (monthsDifference !== inputDate.monthRange - 1) {
    return 'Month range is not correct.'
  }

  // Extract month and year details
  const startMonth = startDate.format('MMM')
  const startYear = startDate.format('YY')
  const endMonth = endDate.format('MMM')
  const endYear = endDate.format('YY')

  // Format the range
  const range =
    startYear === endYear
      ? `${startMonth}-${endMonth} ${endYear}` // Same year
      : `${startMonth} ${startYear}-${endMonth} ${endYear}` // Year transition

  return range
}
export function formatDateRangeYear(inputDate) {
  const moment = require('moment') // Ensure you have moment.js installed
  const start = moment(inputDate.start)
  const end = moment(inputDate.end)

  if (start.year() === end.year()) {
    return start.format('YYYY')
  } else {
    return `${start.format('YY')} - ${end.format('YYYY')}`
  }
}
export function formatDateRangeMonth(inputDate) {
  const moment = require('moment') // Ensure you have moment.js installed
  const start = moment(inputDate.start)
  const end = moment(inputDate.end)

  if (start.year() === end.year()) {
    return `${start.format('MMMM')} - ${end.format('MMMM')}`
  } else {
    return `${start.format('MMMM YY')} - ${end.format('MMMM YY')}`
  }
}
export function getSelectedMonthNames(selectedDate) {
  const months = []
  const startDate = moment(selectedDate.start)
  const endDate = moment(selectedDate.end)

  // Check if start and end year are the same
  const isSameYear = startDate.year() === endDate.year()

  while (startDate.isSameOrBefore(endDate, 'month')) {
    if (isSameYear) {
      // If the years are the same, push only the full month name
      months.push(startDate.format('MMMM'))
    } else {
      // If the years differ, include both month name and the year in 'YY' format
      months.push(startDate.format('MMMM YY'))
    }
    startDate.add(1, 'month') // Move to the next month
  }

  return months
}
export function previousMonthRange(date) {
  // Ensure moment is loaded
  if (typeof moment === 'undefined') {
    console.error('Moment.js is required for this function.')
    return
  }

  // Destructure the input object
  const { monthRange, start, end } = date

  // Parse start and end dates using moment
  const startDate = moment(start).subtract(monthRange, 'months').toDate()
  const endDate = moment(end).subtract(monthRange, 'months').toDate()

  // Return the updated object
  return {
    monthRange,
    start: startDate,
    end: endDate,
  }
}
export function nextMonthRange(date) {
  // Ensure moment is loaded
  if (typeof moment === 'undefined') {
    console.error('Moment.js is required for this function.')
    return
  }

  // Destructure the input object
  const { monthRange, start, end } = date

  // Parse start and end dates using moment
  const startDate = moment(start).add(monthRange, 'months').toDate()
  const endDate = moment(end).add(monthRange, 'months').toDate()
  // Return the updated object
  return {
    monthRange,
    start: startDate,
    end: endDate,
  }
}
export function isSameMonthinDate(dateArray) {
  if (dateArray.length < 2) return false
  let firstDate = moment(dateArray[0].date)
  let secondDate = moment(dateArray[1].date)
  return firstDate.month() !== secondDate.month()
}
export function getTimeZonesByCountryCode(countryCode = 'PK') {
  return moment.tz.zonesForCountry(countryCode.toUpperCase()) || []
}
export function getUTCOffsetByCountryCode(countryCode) {
  if (!countryCode) return ''
  const code = countryCode.toLowerCase()
  const country = countriesList.find((item) => item[1] === code)
  let timezone = country[3]
  if (!timezone) {
    const zones = moment.tz.zonesForCountry(code.toUpperCase())
    if (zones && zones.length) {
      timezone = zones[0]
    } else {
      return ''
    }
  }
  const now = moment.tz(timezone)
  const offsetMinutes = now.utcOffset()
  const sign = offsetMinutes >= 0 ? '+' : '-'
  const absMinutes = Math.abs(offsetMinutes)
  const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0')
  const minutes = String(absMinutes % 60).padStart(2, '0')
  return `${sign}${hours}${minutes}`
}
export function formatRangeToFirstAndLastDay(date) {
  if (!date?.start || !date?.end) return {}

  const startDate = moment(date.start).startOf('month').format('YYYY-MM-DD')
  const endDate = moment(date.end).endOf('month').format('YYYY-MM-DD')

  return {
    startDate,
    endDate,
  }
}
export function getBackDate(date, back, duration) {
  return moment(date).subtract(back, duration).toDate()
}
export const timeToMinutes = (time) => {
  const momentTime = moment(time, DATETIME_CONSTANT.TIME_24_WITHOUT_SECONDS)
  return momentTime.hours() * 60 + momentTime.minutes()
}
export const minutesToTime = (minutes, format) => {
  return moment().startOf('day').add(minutes, 'minutes').format(format)
}
